module.exports = __webpack_public_path__ + "img/electronicFence.f16c2e02.svg";